module.exports = __webpack_public_path__ + "officialStatic/img/vip-bg1.08c22ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/vip-bg1.png
// module id = ku0U
// module chunks = 0